export default __webpack_public_path__ + "static/media/danlami.38d14987.jpeg";